import { createClient } from '@supabase/supabase-js';

// Initialize Supabase client
const supabaseUrl = 'https://lrcpqodcmjdsajotsbmw.supabase.co';
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxyY3Bxb2RjbWpkc2Fqb3RzYm13Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg0NDU4NTAsImV4cCI6MjA2NDAyMTg1MH0.0K097ZS6aLc9X9GzemwtIlFaf7XEgvkyKlcKcFZhM3Y';

export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: {
    persistSession: false,
    autoRefreshToken: false,
    detectSessionInUrl: false
  },
  realtime: {
    params: {
      eventsPerSecond: 10
    }
  }
});